module.exports = __webpack_public_path__ + "img/success_footer_slogan.35bc352e.png";